import {Content, Portal, Root} from '@radix-ui/react-dialog';
import clsx from 'clsx';
import {Suspense} from 'react';

import {Spinner} from '../Spinner/Spinner';

import {useSleeveContainer} from './SleeveContext';

import type {DialogContentProps} from '@radix-ui/react-dialog';

type Props = React.ComponentPropsWithRef<typeof Root> & {
  ref?: React.RefObject<HTMLDivElement>;
  className?: string;
  handlers?: Pick<
    DialogContentProps,
    | 'onOpenAutoFocus'
    | 'onCloseAutoFocus'
    | 'onPointerDownOutside'
    | 'onInteractOutside'
    | 'onEscapeKeyDown'
  >;
};
export const Sleeve = ({
  ref,
  children,
  className,
  handlers,
  ...props
}: Props) => {
  const {containerRef} = useSleeveContainer();

  return (
    <Root
      modal={false}
      defaultOpen={!props.onOpenChange && typeof props.open === 'undefined'}
      {...props}
    >
      <Portal container={containerRef.current}>
        <div className="pointer-events-none absolute inset-y-0 right-0 max-w-full pl-8">
          <Content
            ref={ref}
            className={clsx('pointer-events-auto w-screen max-w-sm', className)}
            forceMount
            onOpenAutoFocus={(e) => e.preventDefault()}
            onCloseAutoFocus={(e) => e.preventDefault()}
            onPointerDownOutside={(e) => e.preventDefault()}
            onInteractOutside={(e) => e.preventDefault()}
            onKeyDown={(e) => e.key === ' ' && e.stopPropagation()}
            onKeyUp={(e) => e.key === ' ' && e.stopPropagation()}
            aria-describedby={undefined}
            {...handlers}
          >
            <div className="divide-slate4 bg-slate-back dark:outline-slate6 flex max-h-screen flex-col divide-y rounded-l-lg shadow-xl dark:outline-1 dark:outline-solid">
              <Suspense fallback={<Spinner padded />}>{children}</Suspense>
            </div>
          </Content>
        </div>
      </Portal>
    </Root>
  );
};

Sleeve.displayName = 'Sleeve';
